import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { LinkKeepUTM } from "../../../shared/components/LinkKeepUTM";
import PropTypes from "prop-types";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";

import { SortableTableHead } from "../../../shared/components/sortableTableHead";
import { TheadTable } from "../theadTable";

import {
  UNASSIGNED,
  getContentStatusFromAllAvailableContent,
} from "../../consts/assignedContentStatus";
import { asyncAssignMyContentFromContentList } from "../../actions/contentActions";
import { PARTICIPANT_HOME_PATH } from "../../../shared/consts/participantHomePath";
import { useStyles } from "./styles";

const headers = [
  {
    id: "Title",
    label: "Title",
    sortable: false,
    numeric: false,
    disablePadding: false,
    cellProps: {
      width: "20%",
    },
  },
  {
    id: "ContentType",
    label: "Type of content",
    sortable: false,
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Description",
    label: "Description",
    sortable: false,
    numeric: false,
    disablePadding: false,
  },
  {
    id: "actions",
    label: "Actions",
    sortable: false,
    numeric: false,
    disablePadding: false,
    cellProps: {
      width: 200,
      align: "right",
    },
  },
];

const handleActionClick = (dispatch, contentId) => {
  dispatch(asyncAssignMyContentFromContentList(contentId));
};

export const ContentTable = ({
  content,
  order,
  orderBy,
  onSortChange,
  filters,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { request, allAssignedContent } = useSelector((state) => ({
    request: state.request.request,
    allAssignedContent: state.content.allAssignedContent,
  }));

  return (
    <>
      <TableContainer
        className="FiltersContainer"
        width="100%"
        component={Paper}
      >
        <TheadTable filters={filters} />
      </TableContainer>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <SortableTableHead
            fields={headers}
            onRequestSort={onSortChange}
            order={order}
            orderBy={orderBy}
          />
          <TableBody>
            {content.map(({ contentId, contentType, title, description }) => (
              <TableRow key={contentId}>
                <TableCell>
                  <LinkKeepUTM
                    to={`${PARTICIPANT_HOME_PATH}/content/${contentId}`}
                    className={[classes.tTruncate, classes.link].join(" ")}
                  >
                    {title}
                  </LinkKeepUTM>
                </TableCell>
                <TableCell component="th" scope="row">
                  <span className={classes.tTruncate}>{contentType}</span>
                </TableCell>
                <TableCell>
                  <span className={classes.tTruncate}>{description}</span>
                </TableCell>
                <TableCell align="right">
                  {!!allAssignedContent[contentId]?.statusId &&
                  allAssignedContent[contentId]?.statusId !== UNASSIGNED ? (
                    <span className={classes.tTruncate}>
                      {getContentStatusFromAllAvailableContent(
                        allAssignedContent[contentId]?.statusId
                      )}
                    </span>
                  ) : (
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={request.isFetching}
                      onClick={() => handleActionClick(dispatch, contentId)}
                    >
                      Mark as To Watch
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

ContentTable.propTypes = {
  content: PropTypes.instanceOf(Object),
  order: PropTypes.string,
  orderBy: PropTypes.string,
  onSortChange: PropTypes.func,
  filters: PropTypes.instanceOf(Array).isRequired,
};

ContentTable.defaultProps = {
  content: [
    {
      contentId: 0,
      name: "",
      description: "",
      contentTypeId: 0,
    },
  ],
  order: "asc",
  orderBy: "",
  onSortChange: (f) => f,
};
